export const getSupportPhoneNumber = (iso2) => {
  if (iso2 === 'SA') {
    return '%2B966115206547'
  }
  return '%2B97145490493'
}

export const WHATSAPP_URL = (phoneNumber) =>
  `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=`

export const generateWhatsappMessage = (orderId, context) => {
  switch (context) {
    case 'address':
      return encodeURIComponent(
        `Hi! Please change the address for the order ${orderId} to the following:`
      )
    case 'help':
      return encodeURIComponent(
        `Hi! Could you please help me with the order ${orderId}`
      )

    default:
      break
  }
}
